'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// throwTypeError :: String -> fn throw new TypeError
var throwTypeError = function throwTypeError(msg) {
  throw new TypeError(msg);
};

// expected :: Constructor|[Constructor] -> String
/* Copyright 2016 Vladimir Starkov <iamstarkov@gmail.com>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

var expected = R.pipe(R.unless(R.is(Array), R.of), R.map(R.pipe(R.call, R.type)), R.join('|'));

// isAnyOfCtors :: Constructor|[Constructor] -> (fn -> a -> Boolean)
var isAnyOfCtors = R.pipe(R.unless(R.is(Array), R.of), R.map(R.is), R.anyPass);

// text :: String -> Constructor|[Constructor] -> a -> String
var text = function text(name, ctors, param) {
  return '`' + name + '` should be an `' + expected(ctors) + '`, but got `' + R.type(param) + '`: ' + param;
};

// contract :: String -> Constructor|[Constructor] -> a -> a|throw new TypeError
var contract = R.curry(function (name, ctors, param) {
  return R.unless(isAnyOfCtors(ctors), function () {
    return throwTypeError(text(name, ctors, param));
  })(param);
});

exports.default = contract;